const initState = {
    loading: false,
    error: "",
    montainRanges: [],
    zones: [],
    hazards: [],
    avalancheSizes: [],
    hazardAspects: [],
    hazardCharacteristics: [],
    hazardSurfaceConditions: [],
    hazardElevation: [],
    hazardLikelihood: [],
    reports: [],
    users: [],
    predictions: [],
}

const globalReducer = (state = initState, action) => {
    switch (action.type) {
        case "FETCH_GLOBAL_REQUEST":
            return {
                ...state,
                loading: true
            }
        case "FETCH_GLOBAL_SUCCESS":
            return {
                ...state,
                loading: false,
                montainRanges: action.payload.montainRanges,
                zones: action.payload.zones,
                hazards: action.payload.hazards,
                avalancheSizes: action.payload.avalancheSizes,
                hazardAspects: action.payload.hazardAspects,
                hazardCharacteristics: action.payload.hazardCharacteristics,
                hazardElevation: action.payload.hazardElevation,
                hazardSurfaceConditions: action.payload.hazardSurfaceConditions,
                hazardLikelihood: action.payload.hazardLikelihood,
                reports: action.payload.reports,
                users: action.payload.users,
                predictions: action.payload.predictions,
                error: ""
            }
        case "FETCH_GLOBAL_FALIUR":
            return {
                ...state,
                loading: false,
                error: action.payload,
                montainRanges: [],
                zones: [],
                hazards: [],
                avalancheSizes: [],
                hazardCharacteristics: [],
                hazardElevation: [],
                hazardSurfaceConditions: [],
                hazardAspects: [],
                hazardLikelihood: [],
                users: [],
                reports: [],
                predictions: [],
            }

        case "SET_GLOBAL_EMPTY":
            return {
                ...state,
                loading: false,
                error: "",
                montainRanges: [],
                zones: [],
                hazards: [],
                avalancheSizes: [],
                hazardCharacteristics: [],
                hazardElevation: [],
                hazardSurfaceConditions: [],
                hazardAspects: [],
                hazardLikelihood: [],
                users: [],
                reports: [],
                predictions: [],
            }

        case "CHANGE_MONTAIN_RANGE_SPRING_CONDTION":
            let newAray = [...state.montainRanges];
            let foundIndex1 = newAray.findIndex(x => x.id === action.payload.id);

            if(action.payload.condition === 'spring'){
                newAray[foundIndex1].spring_condition = action.payload.flag
                newAray[foundIndex1].summer_condition = 0
                newAray[foundIndex1].autumn_condition = 0
            }

            if(action.payload.condition === 'summer'){
                newAray[foundIndex1].summer_condition = action.payload.flag
                newAray[foundIndex1].spring_condition = 0
                newAray[foundIndex1].autumn_condition = 0
            }

            if(action.payload.condition === 'autumn'){
                newAray[foundIndex1].autumn_condition = action.payload.flag
                newAray[foundIndex1].summer_condition = 0
                newAray[foundIndex1].spring_condition = 0
            }

            return {
                ...state,
                montainRanges: newAray,
                loading: false,
            }


        default:
            return state
    }

}

export default globalReducer;